module.exports = __webpack_public_path__ + "static/media/track-zauberflaute.a20c8b61.png";